import React from 'react';

import { Popover } from '@mantine/core';
import { Info } from 'lucide-react';

import { LIABILITY_SEVERITY } from '../../utilities/liabilityBadge';

// ============================================================
// Styles — every className lives here, zero inline Tailwind in JSX
// ============================================================

const s = {
  trigger: 'flex items-center gap-1 cursor-help select-none',
  triggerIcon: 'w-3 h-3 opacity-40 flex-shrink-0',
  dropdown: 'p-2 bg-white shadow-lg border pointer-events-none',
  dropdownSubtitle: 'text-[10px] text-muted-foreground mb-1.5',
  dropdownList: 'flex flex-col gap-1',
  dropdownRow: 'flex items-center gap-2',
  dropdownSwatch: 'text-[9px] font-mono px-1 py-px rounded-sm ring-[1.5px] ring-inset',
  dropdownLabel: 'text-[11px] font-medium text-gray-700',
  dropdownScore: 'text-[10px] text-muted-foreground font-mono ml-auto pl-3',
} as const;

/**
 * Column header for the Liabilities column in InnerChildSequenceTable.
 * Shows "Liabilities" + an info icon that reveals a score-legend popover on hover.
 */
export function LiabilityColumnHeader() {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover opened={open} position="bottom-start" withArrow withinPortal>
      <Popover.Target>
        <div className={s.trigger} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          Liabilities <Info className={s.triggerIcon} />
        </div>
      </Popover.Target>
      <Popover.Dropdown className={s.dropdown}>
        <p className={s.dropdownSubtitle}>Score: –2.0 (critical) → 0.0 (none)</p>
        <div className={s.dropdownList}>
          {LIABILITY_SEVERITY.map((l) => (
            <div key={l.key} className={s.dropdownRow}>
              <span className={`${s.dropdownSwatch} ${l.cls}`}>AA</span>
              <span className={s.dropdownLabel}>{l.label}</span>
              <span className={s.dropdownScore}>{l.score}</span>
            </div>
          ))}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
